import React from "react";

const CalligraphyIllustration = ({ className = "" }) => {
  return (
    <svg
      width="377"
      height="368"
      className={className}
      viewBox="0 0 377 368"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d_142_3478)">
        <rect
          width="220.033"
          height="217.233"
          rx="14"
          transform="matrix(-0.599897 -0.800077 0.793879 -0.608076 182.211 336.785)"
          fill="white"
        />
        <rect
          x="0.193982"
          y="-1.40815"
          width="218.033"
          height="215.233"
          rx="13"
          transform="matrix(-0.599897 -0.800077 0.793879 -0.608076 183.64 334.675)"
          stroke="#C0C1D8"
          strokeWidth="2"
        />
      </g>
      <path
        d="M218.951 74.6059L146.597 130.026C118.1 151.854 112.455 192.831 133.989 221.551V221.551C155.461 250.187 195.864 255.839 224.367 234.193L297.16 178.911"
        stroke="#000208"
        strokeWidth="5"
      />
      <path
        d="M294.566 178.281V178.281C302.231 188.504 300.222 203.09 290.078 210.859L237.043 251.482C208.763 273.143 168.515 267.598 147.146 239.098V239.098C125.777 210.598 131.379 169.935 159.658 148.275L212.693 107.652C222.837 99.8823 224.846 85.2966 217.181 75.0738V75.0738"
        stroke="#000208"
        strokeWidth="5"
      />
      <g filter="url(#filter1_d_142_3478)">
        <path
          d="M228.474 175.004L224.444 168.844L231.227 163.497L233.561 166.898L228.474 175.004Z"
          fill="black"
        />
        <path
          d="M153.698 72.9695L81.2651 128.45C52.7676 150.278 47.1227 191.255 68.6569 219.975V219.975C90.1285 248.611 130.532 254.263 159.034 232.617L231.906 177.275"
          stroke="#000208"
          strokeWidth="26"
        />
        <path
          d="M150.797 70.8235L145.935 64.7219L152.775 59.146L155.329 62.3818L150.797 70.8235Z"
          fill="black"
        />
        <path
          d="M223.841 172.149V172.149C231.506 182.372 229.496 196.957 219.353 204.727L166.317 245.35C138.038 267.01 97.7901 261.466 76.4209 232.966V232.966C55.0517 204.466 60.6533 163.803 88.9325 142.142L141.968 101.519C152.112 93.7498 154.121 79.1642 146.456 68.9413V68.9413"
          stroke="#000208"
          strokeWidth="26"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_142_3478"
          x="46.2144"
          y="28.6469"
          width="312.454"
          height="316.138"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_142_3478"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_142_3478"
            result="shape"
          />
        </filter>
        <filter
          id="filter1_d_142_3478"
          x="38.6417"
          y="59.146"
          width="206.791"
          height="220.485"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_142_3478"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_142_3478"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};

export default CalligraphyIllustration;
